import { Extension } from "@tiptap/core";

export const CommentSelectionExtension = Extension.create({
    name: "commentSelection",

    addOptions() {
        return {
            onSelectionChange: () => {},
        };
    },

    onSelectionUpdate() {
        this.options.onSelectionChange(this.editor);
    },

    onBlur() {
        this.options.onSelectionChange(null);
    },
});